import React from "react";
import { CalendarCheck, CalendarClock } from "lucide-react";

const tabClass = (isActive) =>
  `flex items-center justify-center gap-1.5 px-[14px] py-0 h-[34px] rounded-lg border-0 text-[13px] font-semibold font-poppins transition-all ${
    isActive
      ? "bg-[#0F172A] text-white shadow-md"
      : "bg-[#F8FAFC] text-[#334155] hover:bg-gray-100"
  }`;

const TabSwitcher = ({ activeTab, setActiveTab }) => (
  <div className="flex md:justify-start justify-center items-center mb-0 w-full">
    <div className="inline-flex items-center gap-1 p-1 bg-white rounded-xl border-[1px] border-solid border-[#E2E8F0] shadow-sm">
      <button
        className={tabClass(activeTab === "Appointments")}
        onClick={() => setActiveTab("Appointments")}
      >
        <CalendarCheck size={15} className="flex-shrink-0" />
        Appointments
      </button>
      <button
        className={tabClass(activeTab === "Follow-Ups")}
        onClick={() => setActiveTab("Follow-Ups")}
      >
        <CalendarClock size={15} className="flex-shrink-0" />
        Follow-Ups
      </button>
    </div>
  </div>
);

export default TabSwitcher;
